import { useEffect, useState } from "react";

export const Globe = () => {
	const [three, setThree] = useState(null);

	useEffect(() => {
		if (typeof window === "undefined") return;
		let cancelled = false;
		(async () => {
			try {
				const [{ Canvas }, { OrbitControls }, { Earth }] = await Promise.all([
					import("@react-three/fiber"),
					import("@react-three/drei"),
					import("./Earth"),
				]);
				if (cancelled) return;
				setThree({ Canvas, OrbitControls, Earth });
			} catch (err) {
				console.error("Failed to load globe", err);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, []);

	if (!three) {
		return <div className="globe-wrapper" aria-hidden="true" />;
	}

	const { Canvas, OrbitControls, Earth } = three;

	return (
		<div className="globe-wrapper">
			<Canvas style={{ height: "300px" }}>
				<ambientLight intensity={3} />
				<OrbitControls makeDefault enableZoom={false} />
				<Earth />
			</Canvas>
		</div>
	);
};

export default Globe;
